import type { PointHistoryEventFragment } from '@/gql/__codegen__/graphql';
import { dateFormatFromISOString } from '@/shared/helpers/formatter/dateFormatter';
import { insertCommaDelimiter } from '@/shared/helpers/formatter/insertCommaDelimiter';

function getTitleName(
  data: PointHistoryEventFragment,
  canBeShownAdultContent: boolean
): string {
  if (!['PPV_ADULT', 'EST_ADULT'].includes(data.operationTypeCode ?? '')) {
    return data.itemName ?? '';
  }

  if (canBeShownAdultContent) {
    return data.itemName ?? '';
  }

  return 'その他♥作品';
}

/**
 * なかなか鬼畜仕様なので、丁寧にもみ消す
 * {
 *   ...
 *   "itemDetail": "2023-12-31T23:59:59.000+09:00"
 * },
 * {
 *   ...
 *   "itemDetail": "キャンペーン／ギフトコード適用"
 * },
 */
function getItemDetail(data: PointHistoryEventFragment): string {
  try {
    if (!data.itemDetail) {
      return '';
    }

    // 文字列ならそのまま返す
    if (isNaN(new Date(data.itemDetail).getDate())) {
      return data.itemDetail;
    }

    // 日付なので、日付に変換して返す
    const expireDateString = dateFormatFromISOString(
      data.itemDetail,
      'yyyy年M月d日 HH:mm'
    );
    return `${expireDateString}まで有効`;
  } catch (error) {
    return data.itemDetail ?? '';
  }
}

export const UsageEvent: React.FC<{
  data: PointHistoryEventFragment;
  canBeShownAdultContent: boolean;
}> = ({ data, canBeShownAdultContent }) => {
  const titleName = getTitleName(data, canBeShownAdultContent);

  return (
    <div className="grid grid-cols-[1fr_6rem] items-center gap-2">
      <div className="grid grid-cols-1 gap-1">
        <div className="text-base2 text-main-80">
          {dateFormatFromISOString(data.operationDateTime, 'HH:mm')}
        </div>
        {data.itemType && (
          <div className="text-base1 font-bold cst-halt leading-[1.4] text-main-100">
            {data.itemType}
          </div>
        )}
        {titleName && (
          <div className="text-base2 text-main-80">{titleName}</div>
        )}
        {data.itemDetail && (
          <div className="text-base2 text-main-80">{getItemDetail(data)}</div>
        )}
      </div>
      <div>
        <div className="text-right">
          <div
            className={
              data.pointHistoryType === 'ADDED'
                ? 'cst-font-eng text-h3 font-bold cst-halt leading-[1.4] text-accent-primary'
                : 'cst-font-eng text-h3 font-bold cst-halt leading-[1.4] text-main-100'
            }
          >
            {data.amount > 0 ? '+' : ''}
            {insertCommaDelimiter(data.amount)}
          </div>
          <div className="text-base3 text-main-80">ポイント</div>
        </div>
      </div>
    </div>
  );
};
